class PredictiveSearch extends HTMLElement {
	/**
	 * Constructor to initialize the PredictiveSearch component.
	 */
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');
		this.emptyResults = this.predictiveSearchResults.querySelector('.mm-search-results-empty');

		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);

		// Display the result div when user click inside the search input
		this.input.addEventListener('click', () => {
			
			this.open();
			document.querySelector(".mm-bg-predictive-search").classList.add("mm-active");
			showBgFilter();
		});

		this.input.addEventListener('focusout', (event) => {
			if (!this.contains(event.relatedTarget)) {
				this.close();
				document.querySelector(".mm-bg-predictive-search").classList.remove("mm-active");
				hideBgFilter();
			}
		});

		this.querySelector(".mm-bg-predictive-search").addEventListener('click', (event) => {
			this.close();
			this.querySelector(".mm-bg-predictive-search").classList.remove("mm-active");
			hideBgFilter();
		});
	}

	/**
	 * Event handler for input changes.
	 */
	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	/**
	 * Fetch search results from the server based on the search term.
	 * 
	 * @param {string} searchTerm - The term to search for.
	 */
	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}
	

	/**
	 * Open the predictive search results container.
	 */
	open() {
		const header = document.querySelector('.mm-header');
		const menu = document.querySelector('.mm-mobile-menu-wrapper');
		if (menu.classList.contains("mm-menu-open")) {
			this.predictiveSearchResults.style.zIndex = 2;
		}
		
		header.classList.add("mm-header-scroll");
		this.predictiveSearchResults.classList.add("mm-active");
		updatePredictiveSearchPosition();
		document.querySelector("html").classList.add("stop-scrolling");
	}

	/**
	 * Close the predictive search results container.
	 */
	close() {
		const header = document.querySelector('.mm-header');

		setTimeout(() => {
			header.classList.remove("mm-header-scroll");
		}, 400);
		
		this.predictiveSearchResults.classList.remove("mm-active");
		document.querySelector("html").classList.remove("stop-scrolling");

		// Réinitialisation de la valeur de l'input
		this.input.value = "";
	}

	/**
	 * Debounce function to limit the rate at which a function can fire.
	 * 
	 * @param {Function} fn - The function to debounce.
	 * @param {number} wait - The number of milliseconds to delay.
	 * @returns {Function} - The debounced function.
	 */
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

function updatePredictiveSearchPosition() {
    const predictiveSearch = document.getElementById('predictive-search');
    const searchBar = document.querySelector('.mm-header-search-container');
    const headerMenu = document.querySelector('.mm-header');
    const announceBar = document.querySelector('.mm-section-announcement-bar');

    if (!predictiveSearch) return;

    let headerHeight = headerMenu.offsetHeight;

    // Inclure la hauteur de la barre de recherche si elle est ouverte
    if (searchBar && searchBar.classList.contains('mm-open')) {
        headerHeight += searchBar.offsetHeight;
    }

    // Inclure la hauteur de l'announcement bar si présente
    if (announceBar) {
        const announceBarHeight = window.innerWidth > 768
            ? parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height'))
            : parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height-mobile'));
        const currentHeight = Math.max(0, announceBarHeight - window.scrollY);
        headerHeight += currentHeight;
    }

    // Définir la position top de predictive-search
    predictiveSearch.style.top = `${headerHeight}px`;

    // Définir la max-height de predictive-search
    predictiveSearch.style.maxHeight = `calc(100vh - ${headerHeight}px)`;
}


//Btn clear in search bar

document.addEventListener('DOMContentLoaded', () => {
    // Sélection des éléments nécessaires
    const searchInput = document.getElementById('Search');
    const clearButton = document.querySelector('.mm-icon-clear');

    if (!searchInput || !clearButton) {
        console.error('Les éléments "Search" ou "mm-icon-clear" sont introuvables dans le DOM.');
        return;
    }

    // Gestion de l'affichage du bouton "Clear"
    searchInput.addEventListener('input', () => {
        if (searchInput.value.trim() !== '') {
            clearButton.style.display = 'block'; // Afficher le bouton
        } else {
            clearButton.style.display = 'none'; // Cacher le bouton
        }
    });

    // Gestion du clic sur le bouton "Clear"
    clearButton.addEventListener('click', () => {
        searchInput.value = ''; // Effacer le contenu du champ
        clearButton.style.display = 'none'; // Cacher le bouton
        searchInput.focus(); // Remettre le focus dans le champ
    });

    // Masquer le bouton au chargement initial
    clearButton.style.display = 'none';
});



// Define the custom element
customElements.define('predictive-search', PredictiveSearch);